"use client";

import { useEffect, useState } from "react";
import { useChessSocketContext } from "../_providers/ChessSocketProvider";

export function useActiveGame(): string | null {
    const { socket } = useChessSocketContext();
    const [activeGameRoomCode, setActiveGameRoomCode] = useState<string | null>(
        null,
    );

    useEffect(() => {
        if (!socket) return;

        const onActiveGame = (data: { roomCode: string }) => {
            setActiveGameRoomCode(data.roomCode);
        };

        const onGameOver = () => {
            setActiveGameRoomCode(null);
        };

        const onGameCancelled = () => {
            setActiveGameRoomCode(null);
        };

        socket.on("active_game", onActiveGame);
        socket.on("game_over", onGameOver);
        socket.on("game_cancelled", onGameCancelled);

        return () => {
            socket.off("active_game", onActiveGame);
            socket.off("game_over", onGameOver);
            socket.off("game_cancelled", onGameCancelled);
        };
    }, [socket]);

    return activeGameRoomCode;
}
